/**
 * SPDX-FileCopyrightText: 2022 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

const emojiSet = {}

// Manually chosen subset of emojis, meant to be friendly and non-offensive
emojiSet.face = ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩', '☺️', '😚', '😙', '😋', '😛', '😜', '🤪', '😝', '🤗', '🤠', '🥳', '🥸', '😎', '🤓', '🤡', '👻', '👾', '🤖']
emojiSet.cat_face = ['😺', '😸', '😹', '😻', '😼']
emojiSet.emotion = ['💟', '❣️', '❤️', '🧡', '💛', '💚', '💙', '💜', '🤎', '🖤', '🤍', '💯', '💢', '💥', '💫', '💦', '💬', '🗯️', '💭', '💤']
emojiSet.hand = ['👍', '👍🏻', '👍🏼', '👍🏽', '👍🏾', '👍🏿']
emojiSet.body = ['👀']
emojiSet.animal = ['🐵', '🐒', '🦍', '🦧', '🐶', '🐕', '🦮', '🐩', '🐺', '🦊', '🦝', '🐱', '🐈', '🦁', '🐯', '🐅', '🐆', '🐴', '🐎', '🦄', '🦓', '🦌', '🦬', '🐮', '🐂', '🐃', '🐄', '🐷', '🐖', '🐗', '🐽', '🐏', '🐑', '🐐', '🐪', '🐫', '🦙', '🦒', '🐘', '🦣', '🦏', '🦛', '🐭', '🐁', '🐀', '🐹', '🐰', '🐇', '🐿️', '🦫', '🦔', '🦇', '🐻', '🐨', '🐼', '🦥', '🦦', '🦨', '🦘', '🦡', '🐾', '🦃', '🐔', '🐓', '🐣', '🐤', '🐥', '🐦', '🐧', '🕊️', '🦅', '🦆', '🦢', '🦉', '🦤', '🪶', '🦩', '🦚', '🦜', '🐸', '🐊', '🐢', '🦎', '🐍', '🐲', '🐉', '🦕', '🦖', '🐳', '🐋', '🐬', '🦭', '🐟', '🐠', '🐡', '🦈', '🐙', '🐚', '🐌', '🦋', '🐛', '🐜', '🐝', '🪲', '🐞', '🦗', '🦂', '🪱']
emojiSet.plant = ['💐', '🌸', '💮', '🏵️', '🌹', '🥀', '🌺', '🌻', '🌼', '🌷', '🌱', '🪴', '🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '☘️', '☘', '🍀', '🍁', '🍂', '🍃']
emojiSet.food = ['🍇', '🍈', '🍉', '🍊', '🍋', '🍌', '🍍', '🥭', '🍎', '🍏', '🍐', '🍑', '🍒', '🍓', '🫐', '🥝', '🍅', '🫒', '🥥', '🥑', '🍆', '🥔', '🥕', '🌽', '🌶️', '🌶', '🫑', '🥒', '🥬', '🥦', '🧄', '🧅', '🍄', '🥜', '🌰', '🍦', '🍧', '🍨', '🍩', '🍪', '🎂', '🍰', '🧁', '🥧', '🍫', '🍬', '🍭', '🍮', '🍯']
emojiSet.drink = ['🍼', '🥛', '☕', '🫖', '🍵', '🍶', '🍾', '🍷', '🍸', '🍹', '🍺', '🍻', '🥂', '🥃', '🥤', '🧋', '🧃', '🧉', '🧊']
emojiSet.place = ['🌍', '🌎', '🌏', '🌐', '🧭', '🏔️', '⛰️', '🌋', '🗻', '🏕️', '🏖️', '🏜️', '🏝️', '🏞️', '⛲', '🌁', '🌃', '🏙️', '🌄', '🌅', '♨️', '🎠', '🎡', '🎢', '💈', '🎪']
emojiSet.transport = ['🚂', '🚃', '🚄', '🚅', '🚆', '🚇', '🚈', '🚉', '🚊', '🚝', '🚞', '🚋', '🚌', '🚍', '🚎', '🚐', '🚕', '🚖', '🚗', '🚘', '🚙', '🛻', '🚚', '🚛', '🚜', '🏍️', '🛵', '🦼', '🛺', '🚲', '🛴', '🛹', '🛼', '⚓', '⛵', '🛶', '🚤', '🛳️', '⛴️', '🛥️', '🚢', '✈️', '✈', '🛩️', '🛫', '🛬', '🪂', '💺', '🚁', '🚟', '🚠', '🚡', '🛰️', '🚀', '🛸']
emojiSet.sky = ['🌙', '🌚', '🌛', '🌜', '☀️', '🌝', '🌞', '🪐', '⭐', '🌟', '🌠', '☁️', '⛅', '🌀', '🌈', '🌂', '☂️', '☔', '⛱️', '⚡', '❄️', '🔥', '💧', '🌊']
emojiSet.event = ['✨', '🎈', '🎉', '🎊', '🎋', '🎍', '🎎', '🎏', '🎐', '🎀', '🎁']
emojiSet.sport = ['⚽', '⚾', '🥎', '🏀', '🏐', '🏈', '🏉', '🎾', '🥏', '🎳', '🏏', '🏑', '🏒', '🥍', '🏓', '🏸', '⛸️', '🤿', '🎽', '🎿', '🛷', '🥌']
emojiSet.game = ['🎯', '🪀', '🪁', '🎱', '🔮', '🪄', '🧿', '🪬', '🎮', '🎰', '🎲', '🧩', '🧸', '🪅', '🪆', '♠️', '♠', '♥️', '♥', '♦️', '♦', '♣️', '♣', '♟️', '♟', '🃏', '🀄']
emojiSet.arts = ['🎭', '🎨']
emojiSet.clothing = ['👛', '👜', '👑', '👒', '🎩', '🎓', '🧢', '💎']
emojiSet.sound = ['📢', '📣', '📯', '🔔']
emojiSet.musical_instrument = ['🎷', '🪗', '🎸', '🎹', '🎺', '🎻', '🪕', '🥁', '🪘']
emojiSet.light = ['🔍', '🔎', '🕯️', '💡', '🔦', '🪔']
emojiSet.book_paper = ['📔', '📕', '📖', '📗', '📘', '📙', '📚', '📓', '📒', '📃', '📜', '📄', '📰', '🗞️', '📑']
emojiSet.writing = ['✏️', '✏', '✒️', '✒', '🖋️', '🖋', '🖊️', '🖊', '🖌️', '🖌', '🖍️', '🖍', '📝']
emojiSet.office = ['💼', '📌', '📎', '✂️']

const defaultEmojis = Object.values(emojiSet).reduce((setA, setB) => setA.concat(setB))

/**
 * @param {Array} excludes list of emojis to exclude
 * @param {Array} emojis list of emojis to to pick from
 * @return {string} random emoji
 */
export default function randomEmoji(excludes = [], emojis = defaultEmojis) {
	let filteredEmojis = excludes.length ? emojis.filter(e => !excludes.includes(e)) : emojis
	if (filteredEmojis.length === 0) {
		// Fallback to full emoji set if filtered list is empty
		filteredEmojis = emojis
	}

	return filteredEmojis[Math.floor(Math.random() * filteredEmojis.length)]
}
